console.log('✅ utils-cache.js loaded successfully!'); // Debugging confirmation

//Least Recently Used (LRU) Cache Implementation
// src/utils/lru-cache.js

//export class LRUCache {
//    constructor(maxEntries = 50) {
//        this.maxEntries = maxEntries;
//        this.map = new Map();
//    }

//    get(key) {
//        if (!this.map.has(key)) return undefined;
//        const val = this.map.get(key);
//        // bump it to the top
//        this.map.delete(key);
//        this.map.set(key, val);
//        return val;
//    }

//    set(key, val) {
//        if (this.map.has(key)) {
//            this.map.delete(key);
//        } else if (this.map.size >= this.maxEntries) {
//            const oldestKey = this.map.keys().next().value;
//            this.map.delete(oldestKey);
//        }
//        this.map.set(key, val);
//    }

//    has(key) {
//        return this.map.has(key);
//    }

//    delete(key) {
//        return this.map.delete(key);
//    }

//    clear() {
//        this.map.clear();
//    }
//}

//example
//const filterCache = new LRUCache(100) or const filterCache = new LRUCacheWithTTL(100, 5 * 60 * 1000); // 100 entries, 5‑minute TTL

// usage in your fetch wrapper
//async function fetchWithCache(filters) {
//   const key = JSON.stringify(filters);
//   const hit = filterCache.get(key);
//   if (hit) return hit;

//   const result = await fetchDataSearchPageWithFilters(...);
//   filterCache.set(key, result);
//   return result;
//}

//  filterCache.delete(key);
// filterCache.clear();

// src/utils/lru-ttl-cache.js

/**
 * LRUCache with TTL (time-to-live) support.
 * - maxEntries: maximum number of entries before eviction (LRU)
 * - ttl: time-to-live for each entry in milliseconds
 */
export class LRUCacheWithTTL {
  constructor(maxEntries = 50, ttl = 5 * 60 * 1000) {
    // default TTL: 5 minutes
    this.maxEntries = maxEntries;
    this.ttl = ttl;
    // map keys to { value, timestamp }
    this.map = new Map();
  }

  _isExpired(entry) {
    return Date.now() - entry.timestamp > this.ttl;
  }

  get(key) {
    const entry = this.map.get(key);
    if (!entry) return undefined;
    // if expired, delete and return undefined
    if (this._isExpired(entry)) {
      this.map.delete(key);
      return undefined;
    }
    // bump to top (most recently used)
    this.map.delete(key);
    entry.timestamp = Date.now();
    this.map.set(key, entry);
    return entry.value;
  }

  set(key, value) {
    // if exists, remove so we can re-insert at top
    if (this.map.has(key)) {
      this.map.delete(key);
    }
    // evict oldest if at capacity
    else if (this.map.size >= this.maxEntries) {
      const oldestKey = this.map.keys().next().value;
      this.map.delete(oldestKey);
    }
    // insert new entry with current timestamp
    this.map.set(key, {
      value,
      timestamp: Date.now(),
    });
  }

  has(key) {
    const entry = this.map.get(key);
    if (!entry) return false;
    if (this._isExpired(entry)) {
      this.map.delete(key);
      return false;
    }
    return true;
  }

  delete(key) {
    return this.map.delete(key);
  }

  clear() {
    this.map.clear();
  }

  // Optional: expose current size (unexpired entries count)
  get size() {
    // purge expired entries first
    for (const [key, entry] of this.map) {
      if (this._isExpired(entry)) {
        this.map.delete(key);
      }
    }
    return this.map.size;
  }
}
